import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import posthog from 'posthog-js';
import { hasAnalyticsConsent, safeAnalyticsPath, safeAnalyticsUrl } from './app/services/analytics-privacy';
import { environment } from './environments/environment';

if (!environment.local) {
    try {
        posthog.init(environment.posthog_key, {
            api_host: environment.posthog_host,
            ui_host: environment.posthog_ui_host,
            person_profiles: 'identified_only',
            autocapture: false,
            capture_exceptions: hasAnalyticsConsent(),
            capture_performance: hasAnalyticsConsent(),
            capture_pageview: false,
            capture_pageleave: false,
            disable_session_recording: !hasAnalyticsConsent(),
            session_recording: { recordHeaders: false, recordBody: false },
            persistence: 'sessionStorage',
            loaded: (sdk) => {
                sdk.register({
                    environment: environment.production ? 'prod' : 'dev',
                    app_version: environment.version
                });
            },
            before_send: (event) => {
                if (!hasAnalyticsConsent()) return null;
                if (event) {
                    for (const key of ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer']) {
                        if (typeof event.properties[key] === 'string')
                            event.properties[key] = safeAnalyticsUrl(event.properties[key]);
                    }
                }
                if (event) {
                    for (const key of ['$pathname', '$initial_pathname']) {
                        if (typeof event.properties[key] === 'string')
                            event.properties[key] = safeAnalyticsPath(event.properties[key]);
                    }
                }
                return event;
            }
            // Feature flags are loaded automatically after init; SDK caches them to limit /flags requests (see plan §4b).
        });
    } catch {
        console.warn('[Analytics] initialization_failed');
    }
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
